import * as z from 'zod';
import { localizedTextSchema, type LocalizedTextInput } from './localized';

export const restaurantCategorySchema = z
  .object({
    id: z.string(),
    name: localizedTextSchema.nullish(),
    icon: z.string().nullish(),
    is_active: z.boolean().nullish(),
    created_at: z.string().nullish(),
    updated_at: z.string().nullish(),
  })
  .loose();
export type RestaurantCategory = z.infer<typeof restaurantCategorySchema>;

export const restaurantCategoryResponseSchema = z
  .object({ restaurant_category: restaurantCategorySchema })
  .loose();

export interface CreateRestaurantCategoryInput {
  name: LocalizedTextInput;
}

export interface UpdateRestaurantCategoryInput {
  name?: LocalizedTextInput | undefined;
  is_active?: boolean | undefined;
}
